// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"a56f3c8a","787":"69a18c16"}[chunkId] + ".chunk.js";
};